export enum EnumTipoDeDocumento {
    RG = 1,
    RNE = 2,
    PASSAPORTE = 3,
}
